(() => {
  const digitos = (cont) =>
    [...cont.querySelectorAll('span,div')].filter(
      (e) => !e.children.length && /^\d{1,3}$/.test((e.textContent || '').trim())
    );
  const arrancar = (cont) => {
    const celdas = digitos(cont);
    if (celdas.length < 2 || cont.dataset.clonCountdown) return;
    cont.dataset.clonCountdown = '1';
    const unidades = celdas.length >= 4 ? [86400, 3600, 60, 1] : celdas.length === 3 ? [3600, 60, 1] : [60, 1];
    let total = celdas.reduce((a, c, i) => a + parseInt(c.textContent.trim(), 10) * unidades[i], 0);
    if (!total || total < 0) return;
    const inicial = total;
    const pintar = () => {
      let resto = total;
      unidades.forEach((u, i) => {
        const v = Math.floor(resto / u);
        resto -= v * u;
        celdas[i].textContent = String(v).padStart(2, '0');
      });
    };
    pintar();
    setInterval(() => {
      total = total > 0 ? total - 1 : inicial;
      pintar();
    }, 1000);
  };
  const init = () =>
    document
      .querySelectorAll('[class*="countdown_wrapper"],[class*="countdown-timer"],[class*="countdown"]')
      .forEach(arrancar);
  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', init)
    : init();
})();